import { startRecording, stopRecording } from "../../audio";
import ConnectWallet from "../NavBar/ConnectWallet";

/* This example requires Tailwind CSS v2.0+ */
export default function Hero(props) {
  return (
    <div className="bg-white px-4">
      {!props.isConnected && <ConnectWallet props={props} />}

      <div className="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8 text-center">
        <img
          src={`${props.info.userAvatar}?img-width=150&img-height=150`}
          className="m-auto mb-4 w-32 h-32 rounded-full"
        />
        <h2 className="font-serif mt-8 text-3xl tracking-tight text-gray-900 sm:text-4xl">
          {props.info.name}
        </h2>
        <div className="mt-4">
          <p className="italic text-gray-500 text-sm">{props.info.bio}</p>
        </div>
        <hr className="text-black bg-black mt-4" />
        <div>
          <div className="text-xs font-semibold p-4 mt-4">
            <p>Play any {props.info.name} song and tap the Listen button below.</p>
          </div>
        </div>
        <div>
          <div>
            <div className="mt-8 flex justify-center bg-black rounded-full h-64 w-64 m-auto">
              <div className="inline-flex rounded-md">
                {props.recording ? (
                  <div className="flex align-center justify-center rounded-full animation-pulse w-64 h-64">
                  <button
                    onClick={() =>
                      props.stopRecording(
                        props.setRecording,
                        props.setResponse,
                        props.info.username
                      )
                    }
                    className="inline-flex items-center justify-center px-5 py-3 text-base font-medium rounded-md text-white"
                  >
                    Listening...
                  </button>
                  </div>
                ) : (
                  
                  <button
                    onClick={() =>
                      props.startRecording(
                        props.setRecording,
                        props.setResponse,
                        props.info.username
                      )
                    }
                    className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white"
                  >
                    <span style={{marginRight: "5px"}} className="font-serif italic">Tap</span><span className="font-sans font-light"> to listen</span>
                  </button>
                  
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
